import { Grid, Avatar, Typography, Paper, Box } from '@material-ui/core'
import { useState } from 'react'

import './FacultyList.css'
import FacultyItem from './FacultyItem'

const FacultyList = ({classrooms, facultySelected, createClass}) => {

  const style = {
    mainContainer: {
      display: 'flex',
      gap: '10px'
    },
    itemContainer: {
      border: '1px solid white',
      padding: '10px',
      borderRadius: '5px',
      cursor: 'pointer',
      backgroundColor: 'white',
      transition: '0.2s ease all',
      flexBasis: '300px'
    },
    avatar: {
      padding: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    details: {
      padding: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'start',
      flexDirection: 'column',
    },
    detailsTitle: {
      fontWeight: 'bold'
    },
    newClassroomBtn: {
      flexBasis: '300px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    }
  }

  const openCreateClassForm = () => {
    createClass()
  }

  return (
    <Grid container xs={12} style={style.mainContainer}>
      <Paper onClick={openCreateClassForm} style={style.newClassroomBtn}>
        + Create New Classroom
      </Paper>
      {classrooms.map((classroom) => (
        <FacultyItem classroom={classroom} onClick={facultySelected} />
      ))}
    </Grid>
  )
}

export default FacultyList